import React from 'react'
import "./CardImage.css"


export interface cImages {
    src: string;
    alt: string;
    width: string | number;
    height: string | number;
  }


const CardImage = (props : cImages) => {

    const { src, alt, width = "50px", height = "50px" } = props;

    return (
        <>
            <div className="zoom-wrapper" style={{height : height}}>
                <img 
                    src={src}  
                    alt={alt} 
                    style={{
                        width: width,
                        height: height,
                    }}
                />
            </div>
        </>
    )
}

export default CardImage